<template>
    <div class="form-group mt-2">
        <label class="form-label" for="payment_online">
            Виберiть з випадаючого списку Службу
        </label>
        <div class="" v-if="draw_items.length > 0">
            <v-select
                v-model="active_dep_id"
                id="organizations_list"
                class="imc_reasons"
                :reduce="item => item.id"
                label="title"
                :options="this.draw_items"
                :filterable="false"
            >
                <template slot="no-options">
                    Оберіть організацію
                </template>
                
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        {{ option.title }}
                    </div>
                </template>
            </v-select>
        </div>
    </div>
</template>


<script>
import vSelect from 'vue-select';
export default {
    name: "service_select",
    components : {
        vSelect
    },
    data() {
        return {
            is_load: false,
            items : [],
            current_item : null,
        }
    },
    
    props : {
        active_id : {
            type : Number,
            required : true
        },
    },
    
    created () {
        this.load_items();
    },
    
    methods : {
        async load_items() {
            this.items = [];
            await api.get('/departments').then(({data}) => {
                this.is_load = true;
                if(data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                this.is_load = false;
            });
        },
    },
    
    computed : {
        draw_items() {
            return this.items;
        },
        
        active_dep_id : {
            get() {
                if(parseInt(this.active_id) > 0) {
                    return this.active_id;
                }
                return null;
            },
            set(new_id) {
                this.$emit('on_service_set',new_id);
            }
        },
    }
}
</script>



<style scoped>

</style>